import React, { useState } from "react";
import { Container, Col, Row, CardBody, Card, Progress } from "reactstrap";
import { getMonthlyDepositTextValue, valueEllipsis } from "../../utils/GeneralUtils";
import CaseResponseModel from "../../models/Cases/CaseResponseModel";
import moment from "moment";
import { transformUTCDateWithoutTime } from "../../utils/dateUtil";
import { Navigate, Route, useNavigate } from "react-router-dom";
import { RoutesEnum } from "../../utils/RoutesUtil";
import EllipsisTooltip from "../../utils/EllipsisTooltip";

interface LeadTrackerGridProps {
  CasesData: Array<CaseResponseModel>;
  getCaseDataHandler: (id:string | null | undefined) => void;
}
const CaseTrackerGrid = (props: LeadTrackerGridProps) => {
 const navigate = useNavigate();  

  const [showLeadDetails, setShowLeadDetails] = useState<boolean>(false);
  const [caseId, setCaseId] = useState<string | null | undefined>("");

  const leadDetailsHandler = (id: string | null | undefined) => {
    setShowLeadDetails(true);
    setCaseId(id);
  };
  const editCaseHandler = (id: string | null | undefined) => {
      props.getCaseDataHandler(id)
  }
  const newCases = props?.CasesData.filter(
    (lead: CaseResponseModel) => (lead.status === "NEW_CASE" || lead.status === "DEFAULT" 
    || lead.status === "PRELIMINARY" || lead.status === "DRAFT")
  );
  const inProcess = props?.CasesData.filter(
    (lead: CaseResponseModel) => lead.status === "IN_PROCESS"
  );
  const readyForReviewData = props?.CasesData.filter(
    (lead: CaseResponseModel) => lead.status === "READY_FOR_REVIEW"
  );
  const submittedOrArchivedData = props?.CasesData.filter(
    (lead: CaseResponseModel) => (lead.status ===  "SUBMITTED" || lead.status === "ARCHIVED")
  );
  const applicationInprogress = props?.CasesData.filter(
    (lead: CaseResponseModel) => lead.status === "APPLICATION_INPROGRESS"
  );
  return (
    <>
      {showLeadDetails && (
        // <redirect to={{ pathname: `/caseTracker/details/${caseId}` }} />
        <Navigate to={`/caseTracker/details/${caseId}`} />
      )}
      <Container fluid className="pt-4 containerClass">
        <Row>
          <Col className="gridCardWrapper mb-4">
            <h5 className="headerStatusName">New Case</h5>
            <div className="gridCardBody">
              {newCases.map((newCase: any, index: number) => {
                return (
                  <div key={index}>
                    <div
                      className="singleLead"

                      onClick={newCase.status !== "DRAFT"?() => leadDetailsHandler(newCase.caseId):void(0)}
                    >
                      <Card className=
                      {newCase.status === 'NEW_CASE' ?
                      (newCase?.dueDays < 0 ? ("overDue"):
                      ((newCase.dueDays >= 0 && newCase.dueDays <= 5) ?"approachingOverDue":'')):
                      (newCase.status === 'PRELIMINARY'?"preliminary":'')} 
                      >
                        <CardBody>
                          <Row className="LeadNameRow">
                            <Col md="8" className="LeadName">
                              <h6>{valueEllipsis(newCase.title, 20)}</h6>
                            </Col>
                            <Col md="4">
                              {newCase?.status !== "DRAFT"?
                              <div className="statusBox">
                              <span className="seeDetailsText">See Details</span>
                              </div>
                              :""}
                            </Col>
                          </Row>
                          <Row  style={{margin:"0"}}>
                            <Col>
                              {newCase.caseCode !== null ? (
                                <span className="caseType mx-0">
                                  {newCase.caseCode}
                                </span>
                              ):'' }
                            </Col>
                          </Row>
                          <Row  className="mx-0">
                            {newCase.status !== "DRAFT" ?
                            <div className="invitationSentBox">
                              <div className="inviteMessage">
                                <Col>
                                {newCase.caseType === "LOR" &&  newCase?.companyName !== null ?
                                  <p className="invitationSentTextLOR">
                                    Relationship: <span className="companyNameText">
                                      {}
                                      <EllipsisTooltip text={newCase?.companyName} maxLine={35} />
                                    </span>
                                  </p>
                                  :<p className="invitationSentText">
                                  General
                                  </p>}
                                </Col>
                              </div>
                              <hr />
                              <Col>
                                <div className="dueDateAndDaysDiv">
                                  <div className="dueDateDiv">
                                    <span className="dueDateText"> Due Date</span><br/>
                                    <span className="dueDateValue">
                                      {transformUTCDateWithoutTime(newCase?.dueDate)}
                                    </span>
                                  </div>
                                  <div className="daysDiv">
                                    <span className="daysText"> Days Remaining</span><br/>
                                    <span className="daysValue">{newCase?.dueDays < 0? 
                                    `(${Math.abs(newCase?.dueDays)})`:Math.abs(newCase?.dueDays)} days</span>

                                  </div>
                                </div>
                                <div className="overDueDiv">
                                  {newCase.status === 'NEW_CASE' ?
                                  (newCase?.dueDays < 0 ? (<span className="overDueText">OVERDUE</span>):
                                  ((newCase.dueDays >= 0 && newCase.dueDays <= 5) 
                                  ?<span className="approachingDueDateText">
                                  APPROACHING DUE DATE</span>:'')):
                                 (newCase.status === 'PRELIMINARY'?<span className="preliminaryText">PRELIMINARY CASE
                                 </span>:'')}
                                </div>
                              </Col>
                            </div>:
                            <div className="invitationSentBox">
                              <div className="draftDiv">
                                <span className="draftText">DRAFT</span>
                              </div>
                              <div className="editBtnDiv">
                                <button className="draftEditBtn"
                                onClick={(e) => {e.stopPropagation();
                                  editCaseHandler(newCase.caseId)}}>
                                Edit</button>
                              </div>

                            </div>}
                          </Row>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col className="gridCardWrapper mb-4">
            <h5 className="headerStatusName">In Process</h5>
            <div className="gridCardBody">
              {inProcess.map((inProcessCase: any, index: number) => {
                return (
                  <div key={index}>
                    <div
                      className="singleLead"
                      onClick={() => leadDetailsHandler(inProcessCase.caseId)}
                    >
                      <Card className=
                      {inProcessCase.status === 'IN_PROCESS' ?
                      (inProcessCase?.dueDays < 0 ? ("overDue"):
                      ((inProcessCase.dueDays >= 0 && inProcessCase.dueDays <= 5) ?"approachingOverDue":'')) : ''}>
                        <CardBody>
                          <Row className="LeadNameRow">
                            <Col md="8" className="LeadName">
                              <h6>{valueEllipsis(inProcessCase.title, 20)}</h6>
                            </Col>
                            <Col md="4">
                              <div className="statusBox">
                              <span className="seeDetailsText">See Details</span>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              {inProcessCase.caseCode !== null ? (
                                <span className="caseType mx-0">
                                  {inProcessCase.caseCode}
                                </span>
                              ):'' }
                            </Col>
                          </Row>
                          <Row className="mx-0">
                            <div className="invitationSentBox">
                              <div className="inviteMessage">
                                <Col>
                                {inProcessCase.caseType === "LOR" &&  inProcessCase?.companyName !== null ?
                                  <p className="invitationSentTextLOR">
                                    Relationship: <span className="companyNameText">
                                      <EllipsisTooltip text={inProcessCase?.companyName}maxLine={35} />
                                    </span>
                                  </p>
                                  :<p className="invitationSentText">
                                  General
                                  </p>}
                                </Col>
                              </div>
                              <hr />
                              <Col>
                                <div className="dueDateAndDaysDiv">
                                  <div className="dueDateDiv">
                                    <span className="dueDateText"> Due Date</span><br/>
                                    <span className="dueDateValue">
                                      {transformUTCDateWithoutTime(inProcessCase?.dueDate)}</span>
                                  </div>
                                  <div className="daysDiv">
                                    <span className="daysText"> Days Remaining</span><br/>
                                    <span className="daysValue">{inProcessCase?.dueDays < 0? 
                                    `(${Math.abs(inProcessCase?.dueDays)})`:Math.abs(inProcessCase?.dueDays)} days
                                    </span>
                                  </div>
                                  
                                  
                                </div>
                                <div className="overDueDiv">
                                 {inProcessCase.status === 'IN_PROCESS' ?
                                  (inProcessCase?.dueDays < 0 ? (<span className="overDueText">OVERDUE</span>):
                                  ((inProcessCase.dueDays >= 0 && inProcessCase.dueDays <= 5) 
                                  ? <span className="approachingDueDateText">
                                    APPROACHING DUE DATE</span>:'')): ''}
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col className="gridCardWrapper mb-4">
            <h5 className="headerStatusName">Ready for Review</h5>
            <div className="gridCardBody">
          {readyForReviewData.map((readyForReview: any, index: number) => {
                return (
                  <div key={index}>
                    <div
                      className="singleLead"
                      onClick={() => leadDetailsHandler(readyForReview.caseId)}
                    >
                      <Card className=
                      {readyForReview.status === 'READY_FOR_REVIEW' ?
                      (readyForReview?.dueDays < 0 ? ("overDue"):
                      ((readyForReview.dueDays >= 0 && readyForReview.dueDays <= 5)?"approachingOverDue":'')) : ''}>
                        <CardBody>
                          <Row className="LeadNameRow">
                            <Col md="8" className="LeadName">
                              <h6>{valueEllipsis(readyForReview.title, 20)}</h6>
                            </Col>
                            <Col md="4">
                              <div className="statusBox">
                              <span className="seeDetailsText">See Details</span>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              {readyForReview.caseCode !== null ? (
                                <span className="caseType mx-0  ">
                                  {readyForReview.caseCode}
                                </span>
                              ):'' }
                            </Col>
                          </Row>
                          <Row className="mx-0">
                            <div className="invitationSentBox">
                              <div className="inviteMessage">
                                <Col>
                                {readyForReview.caseType === "LOR" &&  readyForReview?.companyName !== null ?
                                  <p className="invitationSentTextLOR">
                                    Relationship: <span className="companyNameText">
                                      <EllipsisTooltip text={readyForReview?.companyName}maxLine={35} />
                                    </span>
                                  </p>
                                  :<p className="invitationSentText">
                                  General
                                  </p>}
                                </Col>
                              </div>
                              <hr />
                              <Col>
                                <div className="dueDateAndDaysDiv">
                                  <div className="dueDateDiv">
                                    <span className="dueDateText"> Due Date</span><br/>
                                    <span className="dueDateValue">
                                      {transformUTCDateWithoutTime(readyForReview?.dueDate)}
                                    </span>
                                  </div>
                                  <div className="daysDiv">
                                    <span className="daysText"> Days Remaining</span><br/>
                                    <span className="daysValue">{readyForReview?.dueDays < 0? 
                                    `(${Math.abs(readyForReview?.dueDays)})`:Math.abs(readyForReview?.dueDays)} days
                                    </span>
                                  </div>
                                </div>
                                <div className="overDueDiv">
                                {readyForReview.status === 'READY_FOR_REVIEW' ?
                                  (readyForReview?.dueDays < 0 ? (<span className="overDueText">OVERDUE</span>):
                                  ((readyForReview.dueDays >= 0 && readyForReview.dueDays <= 5) 
                                  ? <span className="approachingDueDateText">
                                    APPROACHING DUE DATE</span>:'')): ''}
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col className="gridCardWrapper mb-4">
            <h5 className="headerStatusName">Submitted/Archived</h5>
            <div className="gridCardBody">
            {submittedOrArchivedData.map((submittedOrArchived: any, index: number) => {
                return (
                  <div key={index}>
                    <div
                      className="singleLead"
                      onClick={() => leadDetailsHandler(submittedOrArchived.caseId)}
                    >
                      <Card>
                        <CardBody>
                          <Row className="LeadNameRow">
                            <Col md="8" className="LeadName">
                              <h6>{valueEllipsis(submittedOrArchived.title, 20)}</h6>
                            </Col>
                            <Col md="4">
                              <div className="statusBox">
                              <span className="seeDetailsText">See Details</span>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              {submittedOrArchived.caseCode !== null ? (
                                <span className="caseType mx-0">
                                  {submittedOrArchived.caseCode}
                                </span>
                              ):'' }
                            </Col>
                          </Row>
                          <Row className="mx-0">
                            <div className="invitationSentBox">
                              <div className="inviteMessage">
                                <Col>
                                {submittedOrArchived.caseType === "LOR" &&  submittedOrArchived?.companyName !== null ?
                                  <p className="invitationSentTextLOR">
                                    Relationship: <span className="companyNameText">
                                      <EllipsisTooltip text={submittedOrArchived?.companyName}maxLine={35} />
                                    </span>
                                  </p>
                                  :<p className="invitationSentText">
                                  General
                                  </p>}
                                </Col>
                              </div>
                              <hr />
                              <Col>
                                <div className="dueDateAndDaysDiv">
                                  <div className="dueDateDiv">
                                    <span className="dueDateText"> Due Date</span><br/>
                                    <span className="dueDateValue">
                                      {transformUTCDateWithoutTime(submittedOrArchived?.dueDate)}
                                    </span>
                                  </div>
                                  <div className="daysDiv">
                                    <span className="daysText"> Closed Date</span><br/>
                                    <span className="daysValue"> 
                                    {transformUTCDateWithoutTime(submittedOrArchived?.statusChangedDate)}
                                    </span>
                                  </div>
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CaseTrackerGrid;
